import { render } from "./Welcome.vue?vue&type=template&id=317d1a6e&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=317d1a6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-317d1a6e"
/* hot reload */
if (module.hot) {
  script.__hmrId = "317d1a6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('317d1a6e', script)) {
    api.reload('317d1a6e', script)
  }
  
  module.hot.accept("./Welcome.vue?vue&type=template&id=317d1a6e&scoped=true", () => {
    api.rerender('317d1a6e', render)
  })

}

script.__file = "resources/js/Pages/Welcome.vue"

export default script